import React, { Component } from 'react' // eslint-disable-line
import { listLoader, LIST_MODEL_KEYS } from '../store/list/ListLoader'

export const LIST_PAGE_TYPES = LIST_MODEL_KEYS

/**
 * Higher-order component (HOC) to wrap restricted pages
 */
export function buildListPage(model: string, BaseComponent: any) {
  class ListPage extends Component {
    componentWillMount() {
      listLoader.registerModel(model)
    }

    componentWillUnmount() {
      listLoader.removeModel(model)
    }

    render() {
      return <BaseComponent {...this.props} />
    }
  }
  return ListPage
}
